import { supabase } from '../lib/supabase';

export const fetchBadges = async () => {
  const { data, error } = await supabase?.from('badges')?.select('*')?.order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
};

export const uploadBadgeArtwork = async (file, badgeId) => {
  const ext = file?.name?.split('.')?.pop() || 'png';
  const path = `badges/${badgeId || Date.now()}_${Date.now()}.${ext}`;
  const { error: uploadError } = await supabase?.storage
    ?.from('badge-artwork')
    ?.upload(path, file, { upsert: true, contentType: file?.type });
  if (uploadError) throw uploadError;
  const { data } = supabase?.storage?.from('badge-artwork')?.getPublicUrl(path);
  return data?.publicUrl;
};

export const createBadge = async (badge) => {
  const { data, error } = await supabase?.from('badges')?.insert([{
      badge_name: badge?.badge_name,
      badge_type: badge?.badge_type,
      badge_description: badge?.badge_description || null,
      xp_threshold: badge?.xp_threshold || 0,
      icon: badge?.icon || null,
      artwork_url: badge?.artwork_url || null,
      rarity: badge?.rarity || 'common',
      unlock_difficulty: badge?.unlock_difficulty || 'easy',
    }])?.select()?.single();
  if (error) throw error;
  return data;
};

export const updateBadge = async (id, badge) => {
  const { data, error } = await supabase?.from('badges')?.update({
      badge_name: badge?.badge_name,
      badge_type: badge?.badge_type,
      badge_description: badge?.badge_description || null,
      xp_threshold: badge?.xp_threshold || 0,
      icon: badge?.icon || null,
      artwork_url: badge?.artwork_url !== undefined ? badge?.artwork_url : undefined,
      rarity: badge?.rarity || 'common',
      unlock_difficulty: badge?.unlock_difficulty || 'easy',
      updated_at: new Date()?.toISOString(),
    })?.eq('id', id)?.select()?.single();
  if (error) throw error;
  return data;
};

export const deleteBadge = async (id) => {
  const { error } = await supabase?.from('badges')?.delete()?.eq('id', id);
  if (error) throw error;
};
